module.exports = "/images/kz.svg?924cc96ab7596561809372b66b77567f";